import { render, staticRenderFns } from "./kfForm.vue?vue&type=template&id=49758fc0&scoped=true"
import script from "./kfForm.vue?vue&type=script&lang=js"
export * from "./kfForm.vue?vue&type=script&lang=js"
import style0 from "./kfForm.vue?vue&type=style&index=0&id=49758fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49758fc0",
  null
  
)

export default component.exports